import React from "react";
import DeleteSupportContainer from "../../containers/support/DeleteSupportContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Grid, Box, Typography } from "@material-ui/core";

const DeleteSupport = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("delete_support.title")}
    >
      {profile ? (
        <DeleteSupportContainer support={profile} onClose={handleClose}>
          {({ onSubmit, support }) => (
            <Box
              mt={1}
              boxShadow={{ xs: 0, sm: 2 }}
              display="flex"
              flexDirection="column"
              p={2}
            >
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography color="textPrimary">
                      {t("delete_support.text")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => onSubmit(support)}
                    >
                      {t("delete_support.button_text")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </DeleteSupportContainer>
      ) : null}
    </Modal>
  );
};

export default DeleteSupport;
